import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { motion, useReducedMotion } from "framer-motion";
import { FiArrowRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import WakoLooking from "../../../assets/mascots/wako/Looking.svg";
import WakoRestricted from "../../../assets/mascots/wako/Restricted.svg";
import StatusPage from "./StatusPage";

const MotionBox = motion.create(Box);

export default function RedirectStatusPage({
  to,
  eyebrow = "Un momento",
  title,
  description,
  image = WakoLooking,
  imageAlt = "Wako indicando el siguiente paso",
  seconds = 3,
  actionLabel = "Continuar ahora",
  showLogout = false,
}) {
  const navigate = useNavigate();
  const reduceMotion = useReducedMotion();
  const [remaining, setRemaining] = React.useState(seconds);

  React.useEffect(() => {
    const startedAt = Date.now();
    const redirectTimer = window.setTimeout(() => navigate(to, { replace: true }), seconds * 1000);
    const countdownTimer = window.setInterval(() => {
      setRemaining(Math.max(0, Math.ceil(seconds - (Date.now() - startedAt) / 1000)));
    }, 200);

    return () => {
      window.clearTimeout(redirectTimer);
      window.clearInterval(countdownTimer);
    };
  }, [navigate, seconds, to]);

  return <StatusPage
    image={image}
    imageAlt={imageAlt}
    eyebrow={eyebrow}
    title={title}
    description={description}
    primaryAction={{ label: actionLabel, icon: <FiArrowRight/>, onClick: () => navigate(to, { replace: true }) }}
    showLogout={showLogout}
  >
    <Text mt="3" color="public.fg.default" fontSize="sm" fontWeight="700">
      Continuaremos en {remaining}...
    </Text>
    <Box mt="6" h="4px" overflow="hidden" rounded="full" bg="brand.redSubtle">
      <MotionBox
        h="full" bg="brand.red" transformOrigin="left"
        initial={reduceMotion ? { scaleX: 1 } : { scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: reduceMotion ? 0 : seconds, ease: "linear" }}
      />
    </Box>
  </StatusPage>;
}

export function RestrictedDashboardPage() {
  return <RedirectStatusPage
    to="/perfil"
    image={WakoRestricted}
    imageAlt="Wako explicando un acceso restringido"
    eyebrow="Acceso restringido"
    title="Este espacio es para el equipo de instructores"
    description="Tu cuenta familiar no tiene acceso al dashboard. Te llevaremos de regreso a tu perfil, donde puedes consultar y administrar la información de tu familia."
    seconds={5}
    actionLabel="Volver a mi perfil"
    showLogout
  />;
}
